import script from "./Log.vue?vue&type=script&lang=ts&setup=true"
export * from "./Log.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__